var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 84,
    viewBox: "0 0 97 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33840_7512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8883 2.12463C78.0562 4.09975 78.4483 7.20166 78.4483 7.20166C78.4483 7.20166 75.3212 7.09805 73.1534 5.12293C70.9855 3.14781 70.5934 0.0458984 70.5934 0.0458984C70.5934 0.0458984 73.7204 0.149511 75.8883 2.12463Z",
    fill: "url(#paint0_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6384 74.9548C58.7719 77.3476 58.6585 80.1743 58.6844 80.184C58.6779 80.2196 62.6022 79.122 64.3617 76.4831C66.1246 73.8766 65.2658 71.1762 65.2917 71.1826C65.282 71.2085 62.5017 72.5846 60.6384 74.9548Z",
    fill: "url(#paint1_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3866 83.2437C59.942 82.6608 58.6555 80.0576 58.6588 80.0802C58.7009 80.0932 62.3918 79.0279 65.5707 79.4035C68.782 79.7953 70.6712 81.7866 70.6712 81.8093C70.7166 81.819 66.8701 83.8427 63.3866 83.2469V83.2437Z",
    fill: "url(#paint2_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4469 71.9627C66.1637 74.5886 66.6238 77.3311 66.6465 77.3376C66.6465 77.3732 70.0944 75.6636 71.2545 72.8142C72.4211 69.9973 71.0925 67.5267 71.1184 67.5332C71.1119 67.5591 68.7302 69.3626 67.4437 71.9659L67.4469 71.9627Z",
    fill: "url(#paint3_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6531 79.5074C68.3057 79.5171 66.6012 77.2182 66.6044 77.2408C66.6433 77.2473 69.8773 75.6057 72.9655 75.4308C76.0828 75.2657 78.2669 76.8749 78.2701 76.8944C78.3123 76.8944 75.0394 79.5041 71.6531 79.5074Z",
    fill: "url(#paint4_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3284 67.9222C72.5993 70.6809 73.5714 73.2551 73.5909 73.2551C73.5909 73.2907 76.5462 71.0533 77.1392 68.0906C77.7354 65.1603 76.0115 62.9941 76.0342 62.9941C76.0342 63.02 74.0607 65.183 73.3284 67.9222Z",
    fill: "url(#paint5_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7724 74.5052C75.5773 75.0848 73.5228 73.1485 73.5293 73.1712C73.565 73.1712 76.3258 71.0342 79.265 70.3348C82.2332 69.6419 84.6409 70.8237 84.6441 70.8431C84.683 70.8399 82.0031 73.9288 78.7724 74.5052Z",
    fill: "url(#paint6_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2345 62.9901C78.0303 65.7941 79.4432 68.1222 79.4626 68.1189C79.4691 68.1546 81.9059 65.4768 81.9578 62.4947C82.0193 59.545 79.9616 57.7318 79.9811 57.7285C79.9811 57.7544 78.4418 60.2055 78.2345 62.9901Z",
    fill: "url(#paint7_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.696 68.4363C81.7082 69.5502 79.3816 68.0251 79.3881 68.0445C79.4205 68.038 81.692 65.4931 84.4238 64.3015C87.1814 63.1132 89.7381 63.8385 89.7446 63.8579C89.7803 63.8482 87.7128 67.3192 84.696 68.4363Z",
    fill: "url(#paint8_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1295 57.3374C82.4179 60.1058 84.2067 62.1198 84.2261 62.1133C84.2358 62.1457 86.1412 59.115 85.6811 56.1977C85.2339 53.3095 82.9169 51.901 82.9364 51.8945C82.9429 51.9204 81.8508 54.5885 82.1295 57.3342V57.3374Z",
    fill: "url(#paint9_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3752 61.5111C86.6564 63.1171 84.1256 62.0389 84.1386 62.0583C84.1678 62.0486 85.9306 59.1734 88.3966 57.5317C90.8885 55.8836 93.5133 56.1427 93.523 56.1589C93.5554 56.1427 92.1231 59.8954 89.3752 61.5111Z",
    fill: "url(#paint10_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9682 51.1335C85.7167 53.7886 87.81 55.4367 87.8262 55.4302C87.8392 55.4626 89.1872 52.1664 88.2507 49.3883C87.3305 46.6361 84.8288 45.6679 84.845 45.6582C84.8547 45.6841 84.2293 48.4978 84.9649 51.1335H84.9682Z",
    fill: "url(#paint11_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7647 53.9272C90.3765 55.9768 87.7193 55.3713 87.7323 55.3875C87.7582 55.3713 88.9928 52.2564 91.1348 50.2068C93.2994 48.1508 95.9145 47.9338 95.9274 47.95C95.9566 47.9306 95.1789 51.8646 92.7615 53.9272H92.7647Z",
    fill: "url(#paint12_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7115 44.5472C87.8878 47.0209 90.2112 48.2643 90.2274 48.2513C90.2469 48.2805 91.0181 44.8062 89.6377 42.2418C88.2767 39.6968 85.6616 39.1917 85.6778 39.1787C85.694 39.2014 85.5514 42.0896 86.7115 44.5472Z",
    fill: "url(#paint13_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8159 45.8935C92.8198 48.3349 90.114 48.2119 90.1302 48.2248C90.1529 48.2054 90.8431 44.9286 92.5994 42.5261C94.3785 40.1139 96.8995 39.4274 96.9157 39.4436C96.9417 39.4177 96.838 43.436 94.8127 45.8935H94.8159Z",
    fill: "url(#paint14_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3207 37.746C88.8891 39.9769 91.3713 40.7832 91.3875 40.7702C91.4102 40.7961 91.5852 37.2344 89.7964 34.942C88.0304 32.669 85.3829 32.6301 85.3959 32.6172C85.4153 32.6366 85.775 35.5281 87.3207 37.746Z",
    fill: "url(#paint15_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4802 37.6193C93.9345 40.3845 91.2676 40.7471 91.2838 40.7601C91.3033 40.7374 91.4329 37.3829 92.742 34.689C94.0706 31.9821 96.4167 30.8488 96.4362 30.8586C96.4589 30.8294 97.0519 34.8315 95.4802 37.6161V37.6193Z",
    fill: "url(#paint16_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7504 30.8972C88.6753 32.8335 91.2417 33.1832 91.2514 33.167C91.2806 33.1897 90.8367 29.628 88.6753 27.6626C86.5398 25.7134 83.9377 26.1472 83.9474 26.131C83.9733 26.1472 84.8483 28.9707 86.7504 30.8972Z",
    fill: "url(#paint17_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7122 29.3074C93.685 32.3316 91.1315 33.167 91.151 33.1767C91.1672 33.154 90.7167 29.806 91.5139 26.8854C92.3273 23.9519 94.4141 22.401 94.4368 22.4074C94.4563 22.375 95.7654 26.2573 94.7122 29.3042V29.3074Z",
    fill: "url(#paint18_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9585 24.1723C87.2009 25.7653 89.7705 25.652 89.7803 25.6358C89.8127 25.6552 88.7336 22.181 86.2352 20.5944C83.7659 19.0208 81.2902 19.9112 81.3 19.8918C81.3291 19.9047 82.742 22.5889 84.9585 24.1723Z",
    fill: "url(#paint19_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4601 21.1667C92.0129 24.369 89.6604 25.6577 89.683 25.6641C89.6928 25.6382 88.6493 22.3809 88.8697 19.3146C89.1062 16.2321 90.8431 14.3023 90.8658 14.3088C90.882 14.2764 92.9268 17.9385 92.4569 21.1699L92.4601 21.1667Z",
    fill: "url(#paint20_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9026 17.7438C84.4237 18.9515 86.9189 18.3816 86.9286 18.3655C86.9675 18.3784 85.2274 15.0822 82.4308 13.9166C79.67 12.7574 77.4016 14.0817 77.4113 14.0623C77.447 14.072 79.4107 16.5425 81.9026 17.747V17.7438Z",
    fill: "url(#paint21_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6817 13.402C88.8826 16.7014 86.8184 18.4045 86.8443 18.4078C86.8508 18.3819 85.1917 15.2961 84.7704 12.1618C84.3621 9.01137 85.6616 6.75779 85.6875 6.76102C85.7004 6.72541 88.5002 10.0734 88.6817 13.3987V13.402Z",
    fill: "url(#paint22_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5475 11.7833C80.3083 12.5734 82.648 11.5631 82.6544 11.5437C82.6966 11.5502 80.2792 8.52275 77.2266 7.81041C74.2098 7.09808 72.2396 8.82064 72.2428 8.80121C72.2817 8.80445 74.819 10.99 77.5475 11.7833Z",
    fill: "url(#paint23_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.322 6.22681C84.2358 9.52947 82.5475 11.605 82.5767 11.605C82.5799 11.5791 80.2857 8.74589 79.158 5.63751C78.04 2.50969 78.808 0.000321343 78.8372 0.000321343C78.8469 -0.0352956 82.4211 2.895 83.322 6.22681Z",
    fill: "url(#paint24_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6411 81.052L47.6962 80.4466C52.7157 80.8999 57.719 80.3429 62.57 78.7855C67.2946 77.2702 71.6692 74.8774 75.5707 71.6718C83.6687 65.0212 88.8923 55.5341 90.276 44.9527C91.4102 36.2881 90.8269 28.5689 88.5456 22.0057C86.0958 14.9568 81.7341 9.44261 75.5772 5.61541L75.898 5.10059C82.1748 9.0055 86.6208 14.6265 89.1192 21.8082C91.4329 28.462 92.0226 36.2751 90.8755 45.0336C89.4691 55.7673 84.171 65.3968 75.9531 72.1446C71.99 75.3987 67.5506 77.8271 62.7514 79.3683C57.8227 80.9484 52.7384 81.5183 47.6379 81.0553L47.6411 81.052Z",
    fill: "url(#paint25_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0368 2.12463C18.869 4.09975 18.4769 7.20166 18.4769 7.20166C18.4769 7.20166 21.6039 7.09805 23.7718 5.12293C25.9397 3.14781 26.3318 0.0458984 26.3318 0.0458984C26.3318 0.0458984 23.2047 0.149511 21.0368 2.12463Z",
    fill: "url(#paint26_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2865 74.9548C38.153 77.3476 38.2664 80.1743 38.2405 80.184C38.247 80.2196 34.3228 79.122 32.5632 76.4831C30.8004 73.8766 31.6591 71.1762 31.6332 71.1826C31.6429 71.2085 34.4232 72.5846 36.2865 74.9548Z",
    fill: "url(#paint27_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5386 83.2437C36.9832 82.6608 38.2697 80.0576 38.2664 80.0802C38.2243 80.0932 34.5334 79.0279 31.3545 79.4035C28.1432 79.7953 26.254 81.7866 26.254 81.8093C26.2086 81.819 30.0551 83.8427 33.5386 83.2469V83.2437Z",
    fill: "url(#paint28_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.475 71.9627C30.7582 74.5886 30.2981 77.3311 30.2722 77.3376C30.2722 77.3732 26.8243 75.6636 25.6642 72.8142C24.4976 69.9973 25.8262 67.5267 25.8003 67.5332C25.8068 67.5591 28.1885 69.3626 29.475 71.9659V71.9627Z",
    fill: "url(#paint29_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2689 79.5074C28.6163 79.5171 30.3208 77.2182 30.3175 77.2408C30.2786 77.2473 27.0447 75.6057 23.9565 75.4308C20.8391 75.2657 18.6551 76.8749 18.6518 76.8944C18.6097 76.8944 21.8826 79.5041 25.2689 79.5074Z",
    fill: "url(#paint30_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5968 67.9222C24.3259 70.6809 23.3537 73.2551 23.3343 73.2551C23.3343 73.2907 20.379 71.0533 19.786 68.0906C19.1897 65.1603 20.9137 62.9941 20.891 62.9941C20.891 63.02 22.8644 65.183 23.5968 67.9222Z",
    fill: "url(#paint31_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1496 74.5052C21.3447 75.0848 23.3991 73.1485 23.3926 73.1712C23.357 73.1712 20.5961 71.0342 17.657 70.3348C14.6887 69.6419 12.2811 70.8237 12.2778 70.8431C12.2389 70.8399 14.9188 73.9288 18.1496 74.5052Z",
    fill: "url(#paint32_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6907 62.9901C18.8949 65.7941 17.482 68.1222 17.4626 68.1189C17.4561 68.1546 15.0193 65.4768 14.9674 62.4947C14.9059 59.545 16.9635 57.7318 16.9441 57.7285C16.9441 57.7544 18.4833 60.2055 18.6907 62.9901Z",
    fill: "url(#paint33_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.226 68.4363C15.2137 69.5502 17.5404 68.0251 17.5339 68.0445C17.5015 68.038 15.2299 65.4931 12.4982 64.3015C9.74055 63.1132 7.18381 63.8385 7.17733 63.8579C7.14169 63.8482 9.20911 67.3192 12.226 68.4363Z",
    fill: "url(#paint34_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7957 57.3374C14.5073 60.1058 12.7185 62.1198 12.6991 62.1133C12.6894 62.1457 10.784 59.115 11.2441 56.1977C11.6913 53.3095 14.0082 51.901 13.9888 51.8945C13.9823 51.9204 15.0743 54.5885 14.7957 57.3342V57.3374Z",
    fill: "url(#paint35_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54672 61.5111C10.2655 63.1171 12.7963 62.0389 12.7833 62.0583C12.7542 62.0486 10.9913 59.1734 8.52534 57.5317C6.03342 55.8836 3.40864 56.1427 3.39891 56.1589C3.36651 56.1427 4.7988 59.8954 7.54672 61.5111Z",
    fill: "url(#paint36_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.957 51.1335C11.2085 53.7886 9.11514 55.4367 9.09894 55.4302C9.08598 55.4626 7.73794 52.1664 8.67444 49.3883C9.59473 46.6361 12.0964 45.6679 12.0802 45.6582C12.0705 45.6841 12.6959 48.4978 11.9603 51.1335H11.957Z",
    fill: "url(#paint37_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1572 53.9272C6.54543 55.9768 9.20261 55.3713 9.18965 55.3875C9.16373 55.3713 7.92911 52.2564 5.78716 50.2068C3.62252 48.1508 1.00746 47.9338 0.994499 47.95C0.965335 47.9306 1.74305 51.8646 4.16044 53.9272H4.1572Z",
    fill: "url(#paint38_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2104 44.5472C9.03415 47.0209 6.71073 48.2643 6.69453 48.2513C6.67509 48.2805 5.90385 44.8062 7.2843 42.2418C8.64529 39.6968 11.2604 39.1917 11.2442 39.1787C11.2279 39.2014 11.3705 42.0896 10.2104 44.5472Z",
    fill: "url(#paint39_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10599 45.8934C4.10212 48.3348 6.80792 48.2118 6.79171 48.2247C6.76903 48.2053 6.07881 44.9285 4.32247 42.526C2.54346 40.117 0.0223697 39.4306 0.00292692 39.4435C-0.0229968 39.4176 0.0806981 43.4359 2.10599 45.8934Z",
    fill: "url(#paint40_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60439 37.746C8.036 39.9769 5.5538 40.7832 5.54084 40.7702C5.51816 40.7961 5.34317 37.2344 7.13191 34.942C8.89797 32.669 11.5454 32.6301 11.5325 32.6172C11.513 32.6366 11.1533 35.5281 9.60763 37.746H9.60439Z",
    fill: "url(#paint41_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.44166 37.6193C2.98737 40.3845 5.65427 40.7471 5.63807 40.7601C5.61863 40.7374 5.48901 37.3829 4.17986 34.689C2.85127 31.9821 0.505165 30.8488 0.485723 30.8586C0.463039 30.8294 -0.129967 34.8315 1.44166 37.6161V37.6193Z",
    fill: "url(#paint42_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1748 30.8972C8.24991 32.8335 5.68346 33.1832 5.67374 33.167C5.64457 33.1897 6.08852 29.628 8.24991 27.6626C10.3854 25.7134 12.9875 26.1472 12.9778 26.131C12.9518 26.1472 12.0769 28.9707 10.178 30.8972H10.1748Z",
    fill: "url(#paint43_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.21289 29.3074C3.24012 32.3316 5.79361 33.167 5.77416 33.1767C5.75796 33.154 6.20839 29.806 5.41123 26.8854C4.59787 23.9519 2.51101 22.401 2.48833 22.4074C2.46888 22.375 1.15973 26.2573 2.21289 29.3042V29.3074Z",
    fill: "url(#paint44_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 24.1723C9.72441 25.7653 7.15472 25.652 7.14499 25.6358C7.11259 25.6552 8.19167 22.181 10.6901 20.5944C13.1593 19.0208 15.635 19.9112 15.6253 19.8918C15.5961 19.9047 14.1833 22.5889 11.9668 24.1723Z",
    fill: "url(#paint45_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46184 21.1667C4.90902 24.369 7.26161 25.6577 7.23892 25.6641C7.2292 25.6382 8.27263 22.3809 8.05228 19.3146C7.81573 16.2321 6.07883 14.3023 6.05615 14.3088C6.03995 14.2764 3.99521 17.9385 4.46508 21.1699L4.46184 21.1667Z",
    fill: "url(#paint46_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0193 17.7438C12.4982 18.9515 10.003 18.3816 9.99331 18.3655C9.95443 18.3784 11.6946 15.0822 14.4911 13.9166C17.252 12.7574 19.5203 14.0817 19.5106 14.0623C19.4749 14.072 17.5112 16.5425 15.0193 17.747V17.7438Z",
    fill: "url(#paint47_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24345 13.402C8.04254 16.7014 10.1067 18.4045 10.0808 18.4078C10.0743 18.3819 11.7334 15.2961 12.1547 12.1618C12.563 9.01137 11.2636 6.75779 11.2376 6.76102C11.2247 6.72541 8.42491 10.0734 8.24345 13.3987V13.402Z",
    fill: "url(#paint48_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3777 11.7833C16.6168 12.5734 14.2772 11.5631 14.2707 11.5437C14.2286 11.5502 16.646 8.52275 19.6985 7.81041C22.7154 7.09808 24.6856 8.82064 24.6824 8.80121C24.6435 8.80445 22.1062 10.99 19.3777 11.7833Z",
    fill: "url(#paint49_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5999 6.22681C12.6861 9.52947 14.3744 11.605 14.3452 11.605C14.342 11.5791 16.633 8.74589 17.7639 5.63751C18.8851 2.50969 18.1139 0.000321343 18.0847 0.000321343C18.075 -0.0352956 14.5008 2.895 13.5999 6.22681Z",
    fill: "url(#paint50_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2808 81.052L49.2257 80.4466C44.2062 80.8999 39.2029 80.3429 34.3519 78.7855C29.6273 77.2702 25.2527 74.8774 21.3511 71.6718C13.2532 65.0212 8.02957 55.5341 6.64589 44.9527C5.51173 36.2881 6.09501 28.5689 8.3763 22.0057C10.8261 14.9568 15.1878 9.44261 21.3447 5.61541L21.0239 5.10059C14.7471 9.0055 10.3011 14.6265 7.80274 21.8082C5.48904 28.462 4.89928 36.2751 6.0464 45.0336C7.45277 55.7673 12.7509 65.3968 20.9688 72.1446C24.9319 75.3987 29.3713 77.8271 34.1705 79.3683C39.0992 80.9484 44.1835 81.5183 49.284 81.0553L49.2808 81.052Z",
    fill: "url(#paint51_linear_33840_7512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8451 16.4668H35.1305C34.1873 16.4668 33.4227 17.2308 33.4227 18.1733V18.5396C33.4227 19.482 34.1873 20.246 35.1305 20.246H59.8451C60.7884 20.246 61.553 19.482 61.553 18.5396V18.1733C61.553 17.2308 60.7884 16.4668 59.8451 16.4668Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2186 57.877H59.7775C61.5182 57.877 62.9311 59.2888 62.9311 61.028H32.0629C32.0629 59.2888 33.4759 57.877 35.2165 57.877H35.2186Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2295 21.8301H37.6534V55.4054H43.2295V21.8301Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4111 21.8301H44.835V55.4054H50.4111V21.8301Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5906 21.8301H52.0145V55.4054H57.5906V21.8301Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4833 29.2578C67.4833 29.2578 67.4955 29.274 67.5178 29.3023C67.5158 29.2659 67.4833 29.2578 67.4833 29.2578Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5182 29.3048C67.5284 29.4357 67.1639 29.9145 63.5352 31.531C58.9073 33.5956 58.8827 36.4152 58.8827 36.4152V48.823C58.8827 48.823 62.5584 41.8538 64.682 36.6505C64.682 36.6505 62.3946 45.4142 62.0957 45.8418C62.0957 45.8418 64.2458 45.6147 67.4322 43.014C67.4322 43.014 65.3352 46.1201 61.9339 46.8526C61.9339 46.8526 59.755 52.0539 58.8847 53.3675V55.1702C62.0997 54.1001 68.9229 48.6921 69.6028 40.7244C70.2376 33.2784 67.8376 29.7345 67.5202 29.3027L67.5182 29.3048Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9609 29.2578C27.9609 29.2578 27.9487 29.274 27.9265 29.3023C27.9285 29.2659 27.9609 29.2578 27.9609 29.2578Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9264 29.3048C27.9162 29.4357 28.2807 29.9145 31.9094 31.531C36.5373 33.5956 36.5619 36.4152 36.5619 36.4152V48.823C36.5619 48.823 32.8862 41.8538 30.7626 36.6505C30.7626 36.6505 33.05 45.4142 33.349 45.8418C33.349 45.8418 31.1988 45.6147 28.0124 43.014C28.0124 43.014 30.1094 46.1201 33.5107 46.8526C33.5107 46.8526 35.6896 52.0539 36.5599 53.3675V55.1702C33.3449 54.1001 26.5217 48.6921 25.8418 40.7244C25.207 33.2784 27.607 29.7345 27.9244 29.3027L27.9264 29.3048Z",
    fill: "#F6E895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.887 78.4619L46.1905 81.2325L49.887 84.0004L53.581 81.2325L49.887 78.4619Z",
    fill: "url(#paint52_linear_33840_7512)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33840_7512",
    x1: 70.5934,
    y1: 3.62378,
    x2: 78.445,
    y2: 3.62378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33840_7512",
    x1: 58.6812,
    y1: 75.6833,
    x2: 65.4765,
    y2: 75.6833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33840_7512",
    x1: 58.6588,
    y1: 81.3365,
    x2: 70.6712,
    y2: 81.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33840_7512",
    x1: 66.5493,
    y1: 72.4354,
    x2: 71.7373,
    y2: 72.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33840_7512",
    x1: 66.6044,
    y1: 77.4642,
    x2: 78.2701,
    y2: 77.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33840_7512",
    x1: 73.0562,
    y1: 68.1262,
    x2: 77.2623,
    y2: 68.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_33840_7512",
    x1: 73.5293,
    y1: 72.3649,
    x2: 84.6441,
    y2: 72.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_33840_7512",
    x1: 78.215,
    y1: 62.9221,
    x2: 81.961,
    y2: 62.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_33840_7512",
    x1: 79.3881,
    y1: 66.2313,
    x2: 89.7479,
    y2: 66.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33840_7512",
    x1: 82.0841,
    y1: 57.0072,
    x2: 85.7491,
    y2: 57.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_33840_7512",
    x1: 84.1386,
    y1: 59.264,
    x2: 93.5262,
    y2: 59.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_33840_7512",
    x1: 84.6085,
    y1: 50.5442,
    x2: 88.5845,
    y2: 50.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_33840_7512",
    x1: 87.7355,
    y1: 51.7027,
    x2: 95.9307,
    y2: 51.7027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_33840_7512",
    x1: 85.681,
    y1: 43.715,
    x2: 90.4607,
    y2: 43.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_33840_7512",
    x1: 90.1302,
    y1: 43.8342,
    x2: 96.9222,
    y2: 43.8342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_33840_7512",
    x1: 85.3926,
    y1: 36.6905,
    x2: 91.4005,
    y2: 36.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_33840_7512",
    x1: 91.2838,
    y1: 35.8125,
    x2: 96.5658,
    y2: 35.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_33840_7512",
    x1: 83.9474,
    y1: 29.6345,
    x2: 91.2514,
    y2: 29.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_33840_7512",
    x1: 91.0376,
    y1: 27.7953,
    x2: 95.1205,
    y2: 27.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_33840_7512",
    x1: 81.3,
    y1: 22.6504,
    x2: 89.7803,
    y2: 22.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_33840_7512",
    x1: 88.8405,
    y1: 19.9848,
    x2: 92.5314,
    y2: 19.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_33840_7512",
    x1: 77.4113,
    y1: 15.9759,
    x2: 86.9286,
    y2: 15.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_33840_7512",
    x1: 84.6894,
    y1: 12.586,
    x2: 88.6946,
    y2: 12.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_33840_7512",
    x1: 72.2428,
    y1: 9.86001,
    x2: 82.6544,
    y2: 9.86001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_33840_7512",
    x1: 78.552,
    y1: 5.80264,
    x2: 83.5942,
    y2: 5.80264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_33840_7512",
    x1: 47.6411,
    y1: 43.1524,
    x2: 91.4491,
    y2: 43.1524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_33840_7512",
    x1: 18.4769,
    y1: 0.000567866,
    x2: 26.3318,
    y2: 0.000567866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_33840_7512",
    x1: 31.4453,
    y1: 75.6833,
    x2: 38.2438,
    y2: 75.6833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_33840_7512",
    x1: 26.254,
    y1: 81.3365,
    x2: 38.2664,
    y2: 81.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_33840_7512",
    x1: 25.1879,
    y1: 72.4354,
    x2: 30.3758,
    y2: 72.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_33840_7512",
    x1: 18.6518,
    y1: 77.4642,
    x2: 30.3208,
    y2: 77.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_33840_7512",
    x1: 19.6596,
    y1: 68.1262,
    x2: 23.869,
    y2: 68.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_33840_7512",
    x1: 12.2778,
    y1: 72.3649,
    x2: 23.3959,
    y2: 72.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_33840_7512",
    x1: 14.9642,
    y1: 62.9221,
    x2: 18.7102,
    y2: 62.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_33840_7512",
    x1: 7.17733,
    y1: 66.2313,
    x2: 17.5339,
    y2: 66.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_33840_7512",
    x1: 11.1728,
    y1: 57.0072,
    x2: 14.841,
    y2: 57.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_33840_7512",
    x1: 3.39891,
    y1: 59.264,
    x2: 12.7866,
    y2: 59.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_33840_7512",
    x1: 8.34067,
    y1: 50.5442,
    x2: 12.3135,
    y2: 50.5442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_33840_7512",
    x1: 0.991259,
    y1: 51.7027,
    x2: 9.18965,
    y2: 51.7027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_33840_7512",
    x1: 6.46122,
    y1: 43.715,
    x2: 11.2442,
    y2: 43.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_33840_7512",
    x1: 0.00292692,
    y1: 43.8341,
    x2: 6.79171,
    y2: 43.8341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_33840_7512",
    x1: 5.52464,
    y1: 36.6905,
    x2: 11.5292,
    y2: 36.6905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_33840_7512",
    x1: 0.359344,
    y1: 35.8125,
    x2: 5.63807,
    y2: 35.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_33840_7512",
    x1: 5.67374,
    y1: 29.6345,
    x2: 12.9778,
    y2: 29.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_33840_7512",
    x1: 1.80459,
    y1: 27.7953,
    x2: 5.88434,
    y2: 27.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_33840_7512",
    x1: 7.14175,
    y1: 22.6504,
    x2: 15.6221,
    y2: 22.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_33840_7512",
    x1: 4.39379,
    y1: 19.9848,
    x2: 8.08145,
    y2: 19.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_33840_7512",
    x1: 9.99331,
    y1: 15.9759,
    x2: 19.5106,
    y2: 15.9759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_33840_7512",
    x1: 8.23049,
    y1: 12.586,
    x2: 12.2357,
    y2: 12.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_33840_7512",
    x1: 14.2707,
    y1: 9.86001,
    x2: 24.6824,
    y2: 9.86001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_33840_7512",
    x1: 13.331,
    y1: 5.80264,
    x2: 18.3699,
    y2: 5.80264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_33840_7512",
    x1: 5.47608,
    y1: 43.1524,
    x2: 49.2808,
    y2: 43.1524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_33840_7512",
    x1: 46.1905,
    y1: 81.2325,
    x2: 53.581,
    y2: 81.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D8BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57D24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33840_7512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumicon);
export default __webpack_public_path__ + "static/media/premiumicon.c9917e4d541defdf200e0dae9907c882.svg";
export { ForwardRef as ReactComponent };